import { useCallback, useEffect, useState } from 'react';
import { OpenedInviteCard } from '../../../../ProjectTeam/ProjectTeamInvite/useProjectTeamInvite';
import { EmployersForSelect } from '../../../../../TemporaryConmonents/AddProject/SecondStep/useSecondStep';
import { useDebounce } from '../../../../../shared/hooks/useDebounce';
import { fetchDaData } from '../../../../../TemporaryConmonents/AddProject/helpers/actions';

export const useModalTeamProjectBody = () => {
    const [employersList, setEmployersList] = useState<EmployersForSelect[]>([]);
    const debouncedFetchData = useDebounce((name: string, value: string) => {
        fetchDaData(value).then((data) => {
            setEmployersList(data);
        });
    }, 500);

    const onEmployersListSet = useCallback((value: string) => {
        debouncedFetchData('', value);
    }, []);

    useEffect(() => {
        fetchDaData().then((data) => {
            setEmployersList(data);
        });
    }, []);
    const [openedInviteCard, setOpenedInviteCard] = useState<OpenedInviteCard>(null);
    const [closingCard, setClosingCard] = useState<string | null>(null);
    const onSetClosingCard = (value: string | null) => {
        setClosingCard(value);
    };
    const onOpenedInviteCardChange = useCallback((value: OpenedInviteCard) => {
        setOpenedInviteCard(value);
    }, []);
    return {
        openedInviteCard,
        onOpenedInviteCardChange,
        employersList,
        onEmployersListSet,
        closingCard,
        onSetClosingCard,
    };
};
